export default {
      id: "GBP-usage",
      viewBox: "0 0 26 26",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#GBP",
      toString: function () {
        return this.url;
      }
    }